import { ReducerAction, ReducerState } from 'common/types/reducers';
import { ValuationByAllocation } from 'common/types/valuation';

// eslint-disable-next-line import/prefer-default-export
export const setValuationInfo = (
  state: ReducerState,
  action: ReducerAction<{ valuationInfo: ValuationByAllocation }>
) => ({
  ...state,
  valuationInfo: {
    ...state.valuationInfo,
    ...action.valuationInfo,
  },
});
